import { render, staticRenderFns } from "./capital-turn.vue?vue&type=template&id=4e924e5c&scoped=true&"
import script from "./capital-turn.vue?vue&type=script&lang=js&"
export * from "./capital-turn.vue?vue&type=script&lang=js&"
import style0 from "./capital-turn.vue?vue&type=style&index=0&id=4e924e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e924e5c",
  null
  
)

export default component.exports